import { BookingUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/trade/booking_events_pb';
import { Col, DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

import { bookingStatusLabels } from '../enumLabels';

type BookingUpdatedDetailProps = {
  event: BookingUpdatedEvent;
};

export const BookingUpdatedDetail = ({ event }: BookingUpdatedDetailProps) => {
  const previous = event.previousBooking;
  const current = event.updatedBooking;

  if (!previous || !current) {
    return (
      <Col className="@BookingUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'documentNumber',
      label: 'Booking Number',
      previous: previous.documentNumber,
      current: current.documentNumber,
    },
    {
      field: 'status',
      label: 'Status',
      previous: bookingStatusLabels[previous.status],
      current: bookingStatusLabels[current.status],
    },
    {
      field: 'vesselName',
      label: 'Vessel Name',
      previous: previous.vesselName,
      current: current.vesselName,
    },
    {
      field: 'carrierId',
      label: 'Carrier ID',
      previous: previous.carrierId,
      current: current.carrierId,
    },
    {
      field: 'steamshipLine',
      label: 'Steamship Line',
      previous: previous.steamshipLine,
      current: current.steamshipLine,
    },
    {
      field: 'freightForwarder',
      label: 'Freight Forwarder',
      previous: previous.freightForwarder,
      current: current.freightForwarder,
    },
    {
      field: 'internalNotes',
      label: 'Internal Notes',
      previous: previous.internalNotes,
      current: current.internalNotes,
    },
    {
      field: 'externalNotes',
      label: 'External Notes',
      previous: previous.externalNotes,
      current: current.externalNotes,
    },
  ];

  return (
    <Col className="@BookingUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">Booking</span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id} />
          <FieldDisplay label="Booking Number" value={current.documentNumber} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Changes
        </span>
        <DiffViewer diffs={diffs} previousLabel="Before" currentLabel="After" />
      </Col>
    </Col>
  );
};
